import axios from 'axios';

const apiUrl = process.env.VUE_APP_API_URL;
const apiKey = process.env.VUE_APP_API_KEY;
const accountId = process.env.VUE_APP_ACCOUNT_ID;

export const ParticipantRegister = (name,phone,email, agent_id, whatsapp_notification) => {
    return axios.post(apiUrl+"register", {name: name, phone: phone, email: email, agent_id, whatsapp_notification}).then((response) => {
        const token = response.data.token;
        if (token) {
            localStorage.setItem('authToken', token);
        }
        return response;
    }).catch(error => console.log(error));
};